import { LandingPage } from '../LandingPage';
import { spaConfig } from './config';

export default function SpaLandingPage() {
  return <LandingPage config={spaConfig} />;
}
